<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-inside: avoid;text-align: center;margin: 0;">
<a href="https://earlybirdbooks.com/freebook/index.html?q=613f6faad6c2b37d43d5412a&amp;utm_campaign=front" target="_blank">
<img alt="image" src="love.jpg" style="max-width:100%;max-height:100%;"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// love_1.vue?767f902c